import {useMutation, useQueryClient} from "@tanstack/react-query";
import {deleteProjectApi,} from "../../../../api/correspondent/projectApi";
import useGoToNavigation from "../../../../util/useGotoNavigation";
import {useModal} from "../../../../hooks";

type Props = {
    clear?: () => void;
};

/**
 * 프로젝트 삭제
 * @param props
 * @returns
 */
export const useDeleteProject = ({clear}: Props) => {
    const {goToNavigation} = useGoToNavigation();
    const queryClient = useQueryClient();
    const {handleModal, resetModal} = useModal();

    const {mutate} = useMutation({
        mutationFn: (data: { id: number }[]) => deleteProjectApi(data),
        onSuccess: (res) => {
            if (res.code === "0000") {
                handleModal({
                    isOpen: true,
                    contents: "삭제되었습니다.",
                    type: "alert",
                    closeAction: () => {
                        goToNavigation("customer/project/list", {}, true);
                        queryClient.invalidateQueries({queryKey: ["readProjectList"]});
                        if (clear) {
                            clear();
                        }
                    }
                })
            } else {
                handleModal({
                    isOpen: true,
                    contents: res.msg,
                    type: "alert"
                })
            }
        },
        onError: (err) => {
            console.log(err);
        },
    });

    return {mutate};
};
